import { parser as pythonParser } from "@lezer/python";

export function pythonImportRoots(code) {
    if (typeof code !== "string" || !code) return [];
    const roots = new Set();
    pythonParser.parse(code).iterate({
        enter(node) {
            if (node.name !== "ImportStatement") return;
            const statement = code.slice(node.from, node.to).trim();
            if (statement.startsWith("import ")) {
                const imports = statement.slice("import ".length).split(",");
                for (const imported of imports) {
                    const root = pythonImportRoot(imported.trim().split(/\s+as\s+/i)[0]);
                    if (root) roots.add(root);
                }
                return;
            }
            const match = /^from\s+([A-Za-z_][A-Za-z0-9_.]*)\s+import\b/.exec(statement);
            const root = pythonImportRoot(match?.[1]);
            if (root) roots.add(root);
        },
    });
    return [...roots];
}

export function pythonPackageReferenceRoots(code) {
    if (typeof code !== "string" || !code) return [];
    const roots = new Set(pythonImportRoots(code));
    pythonParser.parse(code).iterate({
        enter(cursor) {
            if (cursor.name === "CallExpression") {
                const node = cursor.node;
                const callee = node.firstChild;
                const argList = node.getChild("ArgList");
                const firstArgument = argList?.firstChild?.nextSibling;
                if (
                    !callee
                    || !firstArgument
                    || firstArgument.name !== "String"
                    || !isDynamicImportCallee(code.slice(callee.from, callee.to))
                ) {
                    return;
                }
                const root = pythonStringImportRoot(
                    code.slice(firstArgument.from, firstArgument.to),
                );
                if (root) roots.add(root);
                return;
            }
            if (cursor.name !== "MemberExpression") return;
            const match = /^sys\s*\.\s*modules\s*\[\s*((?:[rRuU])?["'][^"']*["'])\s*\]$/
                .exec(code.slice(cursor.from, cursor.to));
            const root = pythonStringImportRoot(match?.[1]);
            if (root) roots.add(root);
        },
    });
    return [...roots];
}

function pythonImportRoot(value) {
    if (typeof value !== "string") return null;
    const root = value.trim().split(".")[0];
    return /^[A-Za-z_][A-Za-z0-9_]*$/.test(root) ? root : null;
}

function pythonStringImportRoot(value) {
    if (typeof value !== "string") return null;
    const match = /^(?:[rRuU])?(["'])([A-Za-z_][A-Za-z0-9_.]*)\1$/.exec(value.trim());
    return pythonImportRoot(match?.[2]);
}

function isDynamicImportCallee(value) {
    const compact = value.replace(/\s+/g, "");
    return compact === "__import__"
        || compact === "import_module"
        || compact.endsWith(".import_module");
}
